
import {
  toLakh,
  sumThis,
  numberWithCommas,
  toCurrency,
  sumOf,
  countOf,
  sumAndCountOf,
  showSum,
  showCount,
  showSumAndCount,
  percentChange,
  showBlank,
  changeClassTo,
  mobileNumber,
  panCardNumber,
  validEmail,
  adharNumber,
  allDirectQueries
} from "../../../commonFunctions";
import { controls } from "../../../controls";

const rp721 = {
  label: "Lein Reports",
  pageLabel: "Lein Reports",
  starting: true,
  url: "rp721",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", label: "Deposite Product", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", width: "col-sm-2", name: "deposite_product", displayData: { descn: "deposite_product_code_display", guid: "deposite_product_code_guid", producttype: "deposite_product_type_guid", glrefid: "deposite_product_code", productgroup: "deposite_product_group" }, sendToServer: { dataType: 'product', sendData: [{ varname: 'product_group', fixed: "Deposit" }] } }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "deposite_product_code_display", name: "product_code_display" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.magicDateLabel({ tab: "filter", label: "Deposite Opening Date From To", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "deposite_open_date_from", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "deposite_open_date_to", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", label: "Print Deposite Open and Expiry Date", name: "isDepositeOpenExpiryDate", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Loan Product", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", width: "col-sm-2", name: "loan_product", displayData: { descn: "loan_product_code_display", guid: "loan_product_code_guid", producttype: "loan_product_type_guid", glrefid: "loan_product_code", productgroup: "loan_product_group" }, sendToServer: { dataType: 'product', sendData: [{ varname: 'product_group', fixed: "Loan" }] } }),

    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "loan_product_code_display", }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.magicDateLabel({ tab: "filter", label: "Loan Opening Date From To", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "loan_open_date_from", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "loan_open_date_to", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", label: "Print Loan Open and Expiry Date", name: "isLoanOpenExpiryDate", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "As On Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "as_on_date", width: "col-sm-2", default: "sessiondate" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.magicDateLabel({ tab: "filter", label: "Mark Date From To", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "mark_date_from", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "makr_date_to", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", label: "Released", name: "isReleased", width: "col-sm-4" }),

  ],
  form: [

  ],
  history: {
    perPage: 10,
    reportHeader: "Deposit Accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30,
      },


      {
        Header: "Deposits",
        columns: [
          {
            Header: "GL Sub",
            accessor: "gl_sub_head",
          },
          {
            Header: "Account Number",
            accessor: "account_number",
          },
          {
            Header: "Description",
            accessor: "description",
            // width: 300,
            // rwidth: "*"
          },
          {
            Header: "Amount",
            accessor: "amount",
            type: "currency"
          },
          {
            Header: "Lien Amount",
            accessor: "lien_amount",
            type: "currency"
          },
          {
            Header: "Interest Rate",
            accessor: "interest_rate",
            type: "currency",

          }
        ]
      },
      {
        Header: "Loans",
        columns: [
          {
            Header: "GL Sub",
            accessor: "gl_sub_head",
          },
          {
            Header: "Account Number",
            accessor: "account_number",
          },
          {
            Header: "Description",
            accessor: "description",
            // width: 300,
            // rwidth: "*"
          },
          {
            Header: "Amount",
            accessor: "amount",
            type: "currency"
          },
          {
            Header: "Opening Date",
            accessor: "open_date",
          },
          {
            Header: "Expiry Date",
            accessor: "expiry_date",
          },
          {
            Header: "Interest Rate",
            accessor: "interest_rate",
            type: "currency",

          }
        ]
      },
    ]
  }

}
export default rp721;